import { cmsStrings } from "../terminology";

export type RouteMeta = {
  group: string;
  title: string;
  explanation?: string;
};

const { groups, pages, brand } = cmsStrings;

/** Page titles / breadcrumbs for shell (D3 + L3A catalog). Paths without query. */
const BY_PATH: Record<string, RouteMeta> = {
  "/": {
    group: groups.overview,
    title: pages.overview.title,
  },
  "/announcements": {
    group: groups.content,
    title: pages.announcements.title,
  },
  "/promotions": {
    group: groups.content,
    title: pages.promotions.title,
  },
  "/sponsored": {
    group: groups.content,
    title: pages.sponsored.title,
  },
  "/sites": {
    group: groups.network,
    title: pages.sites.title,
  },
  "/reseller-profiles": {
    group: groups.network,
    title: pages.resellerProfiles.title,
  },
  "/portal-bundles": {
    group: groups.release,
    title: pages.portalBundles.title,
  },
  "/fleet": {
    group: groups.release,
    title: pages.fleet.title,
  },
  "/versions": {
    group: groups.release,
    title: pages.versions.title,
  },
  "/observability": {
    group: groups.operations,
    title: pages.observability.title,
  },
  "/memberships": {
    group: groups.administration,
    title: pages.memberships.title,
  },
  "/organizations": {
    group: groups.administration,
    title: pages.organizations.title,
  },
  "/entitlements": {
    group: groups.administration,
    title: pages.entitlements.title,
  },
  "/users": {
    group: groups.administration,
    title: pages.users.title,
  },
  "/settings": {
    group: groups.administration,
    title: pages.settings.title,
  },
  "/audit": {
    group: groups.administration,
    title: pages.audit.title,
  },
};

const FLEET_TAB: Record<string, RouteMeta> = {
  drift: {
    group: groups.release,
    title: pages.fleetDrift.title,
  },
  inventory: {
    group: groups.release,
    title: pages.fleetInventory.title,
  },
  deployments: {
    group: groups.release,
    title: pages.fleetDeployments.title,
  },
};

const OBS_TAB: Record<string, RouteMeta> = {
  alerts: {
    group: groups.operations,
    title: pages.observabilityAlerts.title,
  },
  backup: {
    group: groups.operations,
    title: pages.observabilityBackup.title,
  },
  aggregates: {
    group: groups.operations,
    title: pages.observabilityAggregates.title,
  },
  overview: {
    group: groups.operations,
    title: pages.observability.title,
  },
};

export function resolveRouteMeta(pathname: string, search: string): RouteMeta {
  const params = new URLSearchParams(search);

  if (pathname === "/" && params.get("section") === "activity") {
    return {
      group: groups.operations,
      title: pages.activity.title,
    };
  }

  if (pathname === "/fleet") {
    const tab = params.get("tab") ?? "inventory";
    return FLEET_TAB[tab] ?? BY_PATH["/fleet"]!;
  }

  if (pathname === "/observability") {
    const tab = params.get("tab") ?? "overview";
    return OBS_TAB[tab] ?? BY_PATH["/observability"]!;
  }

  return (
    BY_PATH[pathname] ?? {
      group: brand.productTitle,
      title: brand.productTitle,
    }
  );
}
